import { render, staticRenderFns } from "./MetricAvailability.vue?vue&type=template&id=01b037a0&"
import script from "./MetricAvailability.vue?vue&type=script&lang=js&"
export * from "./MetricAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports